/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';
import { getContentItemForSlot } from '@/data/utils/getContentItemForSlot';

export const getCartPage = (props: IncomingContent): Layout => ({
	name: 'CartStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: getContentItemForSlot(props, 'first'),
		second: [{ name: 'Cart', id: 'cart' }, ...getContentItemForSlot(props, 'second')],
		footer: [{ name: 'ShortFooter', id: 'short-footer' }],
	},
});
